import { startCase } from 'lodash';
import {
    BQ_CLICKED_CUSTOM_ORDER,
    BQ_CLICKED_PACKAGE_SELECT,
    BQ_CLICKED_REPORT_GIG,
    BQ_GIG_DESCRIPTION_SEE_MORE,
    BQ_CLICKED_CONTACT_SELLER,
    BQ_CLICKED_PACKAGES_TAB,
    BQ_CLICKED_REVIEWS_SNIPPET_MORE,
    BQ_SEEN_BOMBA_COUPON,
    BQ_OPEN_COUPON_ARTICLE,
    BQ_SELLER_BUYER_SPEAK_SAME_LANGUAGE,
    BQ_CLICKED_GALLERY_VIDEO,
    BQ_CLICKED_SELLER_LINK,
    BQ_CLICKED_SELLER_NAME_ANCHOR,
    BQ_CLICKED_TOPNAV,
    BQ_CLICKED_REVIEWS_RATINGS,
    BQ_PAGE_TRANSLATED_BY_EXTENSION,
    BQ_STICKY_EXPERIENCE,
    BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS,
    BQ_SIGNUP_CLICK,
    BQ_NOTABLE_CLIENTS_ABOVE_THE_FOLD_SHOW,
    BQ_NOTABLE_CLIENTS_BELOW_THE_FOLD_SHOW,
    BQ_NOTABLE_CLIENT_HOVERED,
    BQ_NOTABLE_CLIENT_GIG_ELIGIBLE,
    BQ_CLICKED_ON_PAYMENT_DETAILS
} from '../bigQueryEvents';
import { RECURRING_TIME_UNITS } from '../../types/recurringTimeUnits';
import { TIME_UNITS } from '../../types/timeUnits';
import { GIG_TYPES } from '../../types/gig';
import * as pageSections from '../pageSections';

export const PAGE_NAME = 'gig_page';

export const clickActionData = {
    group: 'user_action',
    sub_group: 'website_actions',
    action: {
        type: 'click'
    },
    entity: 'client',
    out_of_session: false
};

export const createBqPackageSelectParams = (data) => ({
    type: BQ_CLICKED_PACKAGE_SELECT,
    group: startCase(data.source),
    gig: { id: data.gigId },
    aux: { package_selected: data.id },
    ...getRecurringParams(data)
});

const getRecurringParams = ({ selectedRecurringOption }) =>
    selectedRecurringOption
        ? buildRecurringOptionParams(selectedRecurringOption)
        : {};

const buildRecurringOptionParams = ({ id, duration, durationTimeUnit, discountPercentage }) => ({
    subscription_option: {
        type: GIG_TYPES.RECURRING,
        id,
        duration,
        time_unit: transformTimeUnit(durationTimeUnit),
        discount: discountPercentage
    }
});

const transformTimeUnit = (durationTimeUnit) => {
    switch (durationTimeUnit){
        case RECURRING_TIME_UNITS.WEEK:
            return TIME_UNITS.WEEK;
        case RECURRING_TIME_UNITS.MONTH:
            return TIME_UNITS.MONTH;
        default:
            return TIME_UNITS.MONTH;
    }
};

export const createBqCustomOrderClickParams = (data) => ({
    type: BQ_CLICKED_CUSTOM_ORDER,
    event_source: data.eventSource,
    group: 'buyer_request',
    action: {
        type: 'click'
    },
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        element: {
            type: 'button',
            text: 'get_a_quote'
        }
    },
    feature: {
        name: 'get_a_quote'
    }
});

export const createBqReportGigClickParams = (data) => ({
    type: BQ_CLICKED_REPORT_GIG,
    group: PAGE_NAME,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    out_of_session: false,
    entity: 'client'
});

export const createBqDescriptionSeeMoreParams = (data) => ({
    type: BQ_GIG_DESCRIPTION_SEE_MORE,
    group: PAGE_NAME,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        element: {
            type: 'text',
            name: 'see_more_gig_description'
        },
        component: {
            name: 'gig_description'
        }
    },
    ...clickActionData
});

export const createBqContactSellerClickParams = (data) => {
    const params = {
        type: BQ_CLICKED_CONTACT_SELLER,
        event_source: data.eventSource,
        gig: { id: data.gigId },
        seller: { id: data.sellerId },
        page: {
            name: PAGE_NAME,
            element: {
                type: 'button'
            },
            component: {
                name: data.name
            }
        },
        ...clickActionData
    };

    return params;
};

export const createBqClickedPackagesTab = (data) => ({
    type: BQ_CLICKED_PACKAGES_TAB,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        name: PAGE_NAME,
        element: {
            type: 'tab',
            ...data.page.element
        }
    },
    ...clickActionData
});

export const createBqReviewsSnippetMoreClickParams = (data) => ({
    type: BQ_CLICKED_REVIEWS_SNIPPET_MORE,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        element: {
            type: 'button',
            name: 'reviews snippet'
        },
        component: {
            name: data.name
        }
    },
    domain: {
        name: 'quality'
    },
    publisher: {
        domain: 'algos',
        sub_domain: 'quality'
    },
    ...clickActionData
});

export const createGigGalleryReportParams = (data) => ({
    type: data.type,
    group: 'gig_page_gallery',
    gig: {
        id: data.gigId
    }
});

export const createSeenCouponParams = ({ userId, couponId, deliveryPackId, discount, sellerId, code, gigId }) => ({
    type: BQ_SEEN_BOMBA_COUPON,
    event_source: PAGE_NAME,
    group: 'user_impressions',
    gig: {
        id: gigId
    },
    seller: {
        id: sellerId
    },
    feature: {
        name: 'coupon'
    },
    entity: 'client',
    coupon: {
        type: 'seller_coupon',
        invitee_user_id: userId,
        id: couponId,
        promo_code: code,
        invitation_id: deliveryPackId,
        discount_percent: discount
    }
});

export const createOpenCouponArticleParams = ({ userId, couponId, deliveryPackId, discount, sellerId, code }) => ({
    type: BQ_OPEN_COUPON_ARTICLE,
    event_source: PAGE_NAME,
    seller: {
        id: sellerId
    },
    feature: {
        name: 'coupon'
    },
    coupon: {
        type: 'seller_coupon',
        invitee_user_id: userId,
        id: couponId,
        promo_code: code,
        invitation_id: deliveryPackId,
        discount_percent: discount
    },
    ...clickActionData
});

export const createBqSellerAndBuyerSpeakSameLanguageParams = ({ gigId, sellerId, commonLanguage }) => ({
    type: BQ_SELLER_BUYER_SPEAK_SAME_LANGUAGE,
    group: PAGE_NAME,
    page: {
        name: PAGE_NAME
    },
    gig: {
        id: gigId
    },
    seller: {
        id: sellerId,
        profile: {
            language: commonLanguage.name,
            language_level: String(commonLanguage.level)
        }
    }
});

export const createBqClickedGalleryVideoParams = ({ gigId, slideIndex }) => ({
    type: BQ_CLICKED_GALLERY_VIDEO,
    position: slideIndex,
    gig: {
        id: gigId
    },
    page: {
        component: {
            name: 'gig_page_video'
        }
    },
    ...clickActionData
});

export const createBqClickedSellerNameAnchor = ({ gigId }) => ({
    type: BQ_CLICKED_SELLER_NAME_ANCHOR,
    gig: {
        id: gigId
    },
    page: {
        component: {
            name: 'gig_page_seller_icon'
        }
    },
    ...clickActionData
});

export const createBqClickedSellerLinkParams = ({ gigId }) => ({
    type: BQ_CLICKED_SELLER_LINK,
    gig: {
        id: gigId
    },
    page: {
        component: {
            name: 'gig_page_seller_name'
        }
    },
    ...clickActionData
});

export const createBqClickedReviewsRatingsParams = ({ gigId }) => ({
    type: BQ_CLICKED_REVIEWS_RATINGS,
    gig: {
        id: gigId
    },
    page: {
        component: {
            name: 'gig_page_rating_stars'
        }
    },
    ...clickActionData
});

export const createBqTopNavClickParams = ({ sectionKey, gigId }) => {
    const sectionEventNameMap = {
        [pageSections.OVERVIEW]: 'overview',
        [pageSections.DESCRIPTION]: 'description',
        [pageSections.FAQ]: 'FAQ',
        [pageSections.REVIEWS]: 'reviews',
        [pageSections.ORDER_DETAILS]: 'order_details',
        [pageSections.RECOMMENDATIONS]: 'recommendations',
        [pageSections.ABOUT_SELLER]: 'about_the_seller',
        [pageSections.PACKAGES_TABLE]: 'compare_packages'
    };

    return {
        type: BQ_CLICKED_TOPNAV,
        gig: {
            id: gigId
        },
        page: {
            element: {
                name: sectionEventNameMap[sectionKey]
            },
            component: {
                name: 'gig_page_top_bar'
            }
        },
        ...clickActionData
    };
};

export const createBqPageTranslatedByExtensionParams = ({ gigId, locale, translationSource }) => ({
    type: BQ_PAGE_TRANSLATED_BY_EXTENSION,
    group: 'user_action',
    entity: 'client',
    feature: {
        name: 'localization'
    },
    gig: {
        id: gigId
    },
    localization: {
        experience_locale: locale,
        translation_source: translationSource
    }
});

export const createBqStickyExperienceParams = ({ gigId, stickyTranslationResponseTime }) => ({
    type: BQ_STICKY_EXPERIENCE,
    group: 'technical_events',
    entity: 'client',
    feature: {
        name: 'localization'
    },
    domain: {
        name: 'localization'
    },
    gig: {
        id: gigId
    },
    http_request : {
        response_time: stickyTranslationResponseTime
    }
});

export const createBqContactSellerOptionsClickParams = (data) => ({
    type: BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS,
    event_source: data.eventSource,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        name: PAGE_NAME,
        element: {
            type: 'button'
        },
        component: {
            name: data.name
        }
    },
    action: {
        type: 'click'
    },
    group: 'buyer_request'
});

export const createBqSignupClickParams = () => ({
    type: BQ_SIGNUP_CLICK,
    group: 'signin flow'
});

export const createBqNotableClientsAboveFoldShowParams = () => ({
    type: BQ_NOTABLE_CLIENTS_ABOVE_THE_FOLD_SHOW,
    group: 'user actions'
});

export const createBqNotableClientsBelowFoldShowParams = () => ({
    type: BQ_NOTABLE_CLIENTS_BELOW_THE_FOLD_SHOW,
    group: 'user actions'
});

export const createBqNotableClientHoverdParams = ({ gigId, sellerId, source, clientData, index }) => ({
    type: BQ_NOTABLE_CLIENT_HOVERED,
    group: 'user actions',
    gig: {
        id: gigId
    },
    seller : {
        id: sellerId,
        client: {
            name: clientData?.name,
            website: clientData?.website,
            project_description: clientData?.interaction_description
        }
    },
    page: {
        element: {
            position: index
        },
        component: {
            position: source
        }
    }
});

export const createBqNotableClientsListHoverdParams = ({ gigId, sellerId, source, clients }) => ({
    type: BQ_NOTABLE_CLIENT_GIG_ELIGIBLE,
    group: 'user actions',
    page: {
        component: {
            num_of_elements: clients?.length,
            metadata: clients?.join(),
            position: source
        }
    },
    gig: {
        id: gigId
    },
    seller: {
        id: sellerId
    }
});

export const createBqFinalPricePaymentDetailsClickedParams = (data) => ({
    type: BQ_CLICKED_ON_PAYMENT_DETAILS,
    group: 'user actions',
    event_source: data.event_source,
    action: {
        type: 'click'
    },
    localization: {
        experience_locale: data.locale,
        display_currency: data.currency,
        formatting_locale: data.formattingLocale
    },
    gig: {
        id: data.gigId
    },
    seller: {
        id: data.sellerId
    },
    buyer: {
        id: data.userId
    }
});
